import Icon from 'veui/components/Icon'
import { IconStrikethrough } from 'dls-icons-vue'

Icon.register('strikethrough', IconStrikethrough)
